import { render, staticRenderFns } from "./SubmitTicketCard.vue?vue&type=template&id=1a416bce&"
import script from "./SubmitTicketCard.vue?vue&type=script&lang=js&"
export * from "./SubmitTicketCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports